$(document).ready(function(){
  $('.cv_custom_index_product_slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.cv_custom_banner_slider').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear'
  });

  $('.cv_index_logo_Slider').slick({
    dots: true,
    arrows:false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.cv_custom_upsell_slider').slick({
    dots: false,
    infinite: true,

    fade: false
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 5,
    arrows:false,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,

    focusOnSelect: true,
    autoplay:true,
    infinite:true,
    vertical:true
  });


  $('.cv_custom_feature_Content_slider').slick({
    dots: true,
    autoplay:true,
    arrows: true,
    speed: 300,
    arrows:false,
    slidesToShow: 2,
    slidesToScroll: 1,


    responsive: [

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.cv_to_the_Top').on('click', function (e) {
    e.preventDefault()

    $('html, body').animate(
      {
        scrollTop: $($(this).attr('href')).offset().top -100,
      },
      500,
      'linear'
    )
  });
  $('.cv_to_the_Top_index').on('click', function (e) {
    e.preventDefault()

    $('html, body').animate(
      {
        scrollTop: $($(this).attr('href')).offset().top -100,
      },
      500,
      'linear'
    )
  });
});

$(document).ready(function() {
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
      .siblings(".content")
      .slideUp(200);
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    } else {
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
      .siblings(".content")
      .slideDown(200);
    }
  });
});
$(document).ready(function(){
  $('.tab-link-1').addClass('current');
  $('.tab-content-1').addClass('current');
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })
  $('.cv_Custom_slider_number_part_index-1').addClass('active');
});
$(document).on('click', '.cv_Custom_slider_number_part_index', function(){
  $(this).addClass('active');
  $(this).siblings('.cv_Custom_slider_number_part_index').removeClass('active');
  var cv_custom_data_img = $(this).attr('data-img-number');
  $(this).parents('.cv_custom_number_Slider_part_Content').siblings('.cv_custom_index_number_Featured_image_part').find('.cv_custom_index_number_featured_image_inner_part img').attr('src',cv_custom_data_img);


});

$(document).on('click','.cv_custom_product_submit_btn', function(e){
  var thisbtn = $(this);
  e.preventDefault();
  var varID = $(this).parents('.product-form').serialize();
  console.log(varID);
  $.ajax({
    url:'/cart/add',
    type:'POST',
    dataType: 'HTML',
    data: varID,
    success: function(response){
      $('#cartForm').load(' #cartForm');

      $('.hs-count-products-cart').html($(response).find('.hs-count-products-cart').html())
      $('.cv_Custom_Count_number_cart ').html($(response).find('.cv_Custom_Count_number_cart ').html())
      $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('cart_drawer_open');
      $('body').addClass('drawer_open');
      $('.cv_custom_upsell_slider').slick({
        dots: false,
        infinite: true,

        fade: false
      });
    },
    error: function(){
      $(thisbtn).text('Low Quantity');
      setTimeout(function(){
        $(thisbtn).text('加入');
      },1000);
    }   
  });
});


$(document).on('click','.cv_custom_product_submit_to_Cart', function(e){
  var thisbtn = $(this);
  e.preventDefault();
  var varID = $(this).parents('.product-form').serialize();
  console.log(varID);
  $.ajax({
    url:'/cart/add',
    type:'POST',
    dataType: 'HTML',
    data: varID,
    success: function(response){
      window.location.href = "/cart";
    },
    error: function(){
      $(thisbtn).text('Low Quantity');
      setTimeout(function(){
        $(thisbtn).text('加入');
      },1000);
    }   
  });
});

$(document).on('click touchstart', '.cv_Custom_Drawer_close', function(e){
  e.preventDefault();
  $('.cart_drawer').removeClass('cart_drawer_open');
  $('body').removeClass('drawer_open');
});

$(document).on('click touchend', '.site-header__cart', function(e){
  e.preventDefault();
  $('.cart_drawer').addClass('cart_drawer_open');
  $('body').addClass('drawer_open');
});

///// Cart minus button
$(document).on('click', '.cartdrawersub', function(e){
  e.preventDefault();
  var Coll_cart, rlene1 = [];
  if ($(this).next().val() > 1) {
    if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
    var data = $(this).parents('#cartForm').serialize();
    $.ajax({
      url:'/cart/update',
      type:'POST',
      dataType: 'HTML',
      data:data,
      success: function(response){
        $('.hs-count-products-cart').html($(response).find('.hs-count-products-cart').html())
        $('.cart_drawer').html($(response).filter('.cart_drawer').html());
        $('.cv_custom_upsell_slider').slick({
          dots: false,
          infinite: true,
          speed: 500,
          fade: false
        });
      }
    });
  }
});

///////////////

////// Cart plus button
$(document).on('click', '.cartdraweradd', function(e){
  e.preventDefault();
  $(this).prev().val(+$(this).prev().val() + 1);
  var data = $(this).parents('#cartForm').serialize();
  $.ajax({
    url:'/cart/update',
    type:'POST',
    dataType: 'HTML',
    data:data,
    success: function(response){
      $('.hs-count-products-cart').html($(response).find('.hs-count-products-cart').html())
      $('.cart_drawer').html($(response).filter('.cart_drawer').html());
      $('.cv_custom_upsell_slider').slick({
        dots: false,
        infinite: true,

        fade: false
      });
    }
  });

});



$(document).on('click','.cv_custom_remove_Cart_item',function(e){
  e.preventDefault();

  var url = $(this).attr('href');
  $.ajax({        
    url:url,
    type:'GET',
    success: function(response){
      $('.cv_Custom_Count_number_cart ').html($(response).find('.cv_Custom_Count_number_cart ').html())
      $('.cart_drawer').html($(response).filter('.cart_drawer').html());
      $('.cv_custom_upsell_slider').slick({
        dots: false,
        infinite: true,

        fade: false
      });

    }          
  });  
}); 



$(document).on('click','.cv_Custom_upsell_Add_To_btn', function(e){

  e.preventDefault();
  var thisbtn = $(this);
  $('.hs-add--to--cart').text('');
  $('.hs--loading').show();
  var varID = $(this).attr('data-product-id');
  $.ajax({
    url:'/cart/add',
    type:'POST',
    dataType: 'HTML',
    data: {
      id: varID,
      quantity : 1,
    },
    success: function(response){
      $('#cartForm').load(' #cartForm');
      $('.cv_Custom_Count_number_cart ').html($(response).find('.cv_Custom_Count_number_cart ').html())
      $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('cart_drawer_open');
      $('body').addClass('drawer_open');
      $('.cv_custom_upsell_slider').slick({
        dots: false,
        infinite: true,

        fade: false
      });

      // $('.hs--loading').hide();
    },
    error: function(){
      $(thisbtn).text('Low Quantity');
      setTimeout(function(){
        $(thisbtn).text('加入');
      },1000);
    }   
  });
});

$(document).click(function (e) {
  if (!$(e.target).closest('.cart_drawer, .site-header__cart').length) {
    $('.cart_drawer').removeClass('cart_drawer_open');
    $('body').removeClass('drawer_open');

  }
});

$(document).on('mouseover', '.cv_custom_index_collections_main_image_text_outer', function(){

  // After animation completed:
  $(this).find( ".cv_custom_index_Collection_text_part_inner" ).hide();
  $(this).addClass('cv_Custom_Section_light_part');

});
$(document).on('mouseout', '.cv_custom_index_collections_main_image_text_outer', function(){

  // After animation completed:
  $(this).find( ".cv_custom_index_Collection_text_part_inner" ).show();
  $(this).removeClass('cv_Custom_Section_light_part');

});



$( document ).ready(function() {
$(".index-slide-inner").slick({
   
  infinite: true,
 autoplay: true,
    autoplaySpeed: 5000,
      speed: 3000,
adaptiveHeight: true,
  slidesToShow: 1
  
      });


});
